import React, { Component } from "react";
import {
  MDBNavbarBrand,
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavbarToggler,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBContainer,
  MDBIcon,
} from "mdbreact";
import Background from "../assets/images/bg_page.png";
import axios from "axios";
import packkagee from "../../package.json";
import { admission } from "../Pages/ADMISSION";

export default class HeadersPresent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseID: "",
      name: "",
      LEVEL_OPEN_ID: null,
      checkstatus: null,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    axios
      .get(
        admission+"/student/loadpresent/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((res) => {
        res.data = res.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
        this.setState({
          name: "คุณ" + res.data[0]["FRISTNAME_LOGIN"] + " " + res.data[0]["LASTNAME_LOGIN"],
        });
        this.setState({ LEVEL_OPEN_ID: res.data[0]["LEVEL_OPEN_ID"] });
        this.setState({ checkstatus: "1" });
        // axios.get("https://admission.kpru.ac.th/admission2017/student/creckprecent1/" + res.data[0]["REGISTER_ID"]).then((response) => {
        //   if (response.data === 0) {
        //     this.setState({ checkstatus: "0" })
        //   } else {
        //     this.setState({ checkstatus: "1" })
        //   }
        // })
      });
  }

  toggleCollapse = (collapseID) => () =>
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));

  handleClick(event) {
    localStorage.clear();
    window.location.href = "/" + packkagee.name;
  }

  render() {
    return (
      <div
        className="bg-image card shadow-1-strong white-text"
        style={{
          backgroundImage: `url(${Background})`,
          backgroundRepeat: "no-repeat, repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div class="mask pt-3 pb-3 pl-3 pr-3" style={{ backgroundColor: "rgba(65, 65, 65, 0.8)" }}>
          <div class="d-flex justify-content-center align-items-center h-100">
            <MDBContainer fluid>
              <MDBNavbar className="#fb8c00 orange darken-1" dark expand="md">
                {this.state.checkstatus === "0" ? (
                  <>
                    <MDBNavbarBrand
                      onClick={(e) => {
                        window.location.pathname = "/admission/Insertpresent1";
                      }}
                    >
                      <h4>ระบบรับสมัครนักศึกษา</h4>
                    </MDBNavbarBrand>
                  </>
                ) : (
                  <>
                    <MDBNavbarBrand
                      onClick={(e) => {
                        window.location.pathname = "/admission/Present";
                      }}
                    >
                      <h4>ระบบรับสมัครนักศึกษา</h4>
                    </MDBNavbarBrand>
                  </>
                )}
                <MDBNavbarToggler onClick={this.toggleCollapse("navbarCollapse3")} />
                <MDBCollapse id="navbarCollapse3" isOpen={this.state.collapseID} navbar>
                  <MDBNavbarNav left>
                    <MDBNavItem>
                      <MDBDropdown>
                        <div className="d-flex flex-row">
                          <MDBDropdownToggle nav caret>
                            <span className="mr-2">กรอกข้อมูลรายงานตัว</span>
                          </MDBDropdownToggle>
                          <span
                            className="mr-2 text-white d-flex align-items-center "
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="text-white"
                              style={{ fontWeight: "500" }}
                              onClick={(e) => {
                                window.location.pathname = "/admission/waiver";
                              }}
                            >
                              {" "}
                              แบบฟอร์มขอสละสิทธิ์การเข้าศึกษา
                            </div>
                          </span>
                        </div>

                        <MDBDropdownMenu>
                          <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent1"}>
                            ข้อมูลประวัติส่วนตัว
                          </MDBDropdownItem>
                          {this.state.checkstatus !== "0" ? (
                            <>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent2"}>
                                ข้อมูลประวัติการศึกษา
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent3"}>
                                ข้อมูลที่อยู่
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent4"}>
                                ข้อมูลผู้ปกครอง
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent5"}>
                                ข้อมูลการมีงานทำ
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent6"}>
                                ข้อมูลความสามารถพิเศษ
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent7"}>
                                ข้อมูลช่องทางการรับข่าวสารการรับสมัคร
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent8"}>
                                ข้อมูลรูปประจำตัว
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent9"}>
                                ข้อมูลไฟล์เอกสารประกอบการรายงานตัว
                              </MDBDropdownItem>
                              {this.state.LEVEL_OPEN_ID === "4" ||
                              this.state.LEVEL_OPEN_ID === "19" ? (
                                <>
                                  <MDBDropdownItem href={"/" + packkagee.name + "/Insertpresent10"}>
                                    ข้อมูลไฟล์เอกสารผลคะแนน PAT 5
                                  </MDBDropdownItem>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </MDBDropdownMenu>
                      </MDBDropdown>
                    </MDBNavItem>
                  </MDBNavbarNav>
                  <MDBNavbarNav right>
                    <MDBNavItem>
                      <MDBDropdown>
                        <MDBDropdownToggle nav caret>
                          <MDBIcon icon="user" /> <span className="mr-2">{this.state.name}</span>
                        </MDBDropdownToggle>
                        <MDBDropdownMenu>
                          <MDBDropdownItem>
                            <a
                              class="nav-link black-text active"
                              aria-current="page"
                              onClick={this.handleClick}
                            >
                              ออกจากระบบ
                            </a>
                          </MDBDropdownItem>
                        </MDBDropdownMenu>
                      </MDBDropdown>
                    </MDBNavItem>
                  </MDBNavbarNav>
                </MDBCollapse>
              </MDBNavbar>
              <br />
              <br />

              <div id="pageintro" className="hoc clear">
                <article>
                  <h1 className="heading">มหาวิทยาลัยราชภัฏกำแพงเพชร</h1>
                  <p>
                    เปิดรับสมัครนักศึกษาใหม่ <span className="style4">ประจำปีการศึกษา 2565</span>
                  </p>
                  ภาคปกติ - ภาคกศ.บป. &nbsp;<i className="fa fa-phone style4"></i>
                  &nbsp;&nbsp;&nbsp;(055) 706 547 |{" "}
                  <a
                    className="text-white style4"
                    href="https://www.facebook.com/kpru.register"
                    target="_blank"
                  >
                    Facebook
                  </a>
                  <br />
                  ปริญญาโท - ปริญญาเอก &nbsp;<i className="fa fa-phone style4"></i>
                  &nbsp;&nbsp;&nbsp;(055) 706 555 ต่อ 1770, 1780 |{" "}
                  <a
                    className="text-white style4"
                    href="https://www.facebook.com/graduateskpru/"
                    target="_blank"
                  >
                    Facebook
                  </a>
                  <br />
                  ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู &nbsp;<i className="fa fa-phone style4"></i>
                  &nbsp;&nbsp;&nbsp;(055) 706 555 ต่อ 2010 |{" "}
                  <a
                    className="text-white style4"
                    href="https://www.facebook.com/edukpru/"
                    target="_blank"
                  >
                    Facebook
                  </a>
                </article>
              </div>
            </MDBContainer>
          </div>
        </div>
      </div>
    );
  }
}
